import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Navigationbar from '../../Navigation/NavigationBar';
import './MainLayout.scss';

import { RootState } from '../../../redux/store';
import { useAppDispatch } from '../../../hooks/redux';
import { setSideBarOpen } from '../../../redux/reducers/ui/sideBarReducer';
import Logo from '@/components/Logo/logo';

type MainLayoutProps = {
	content: any;
	sidebar: any;
};

const MainLayout: FC<MainLayoutProps> = ({ content, sidebar }) => {
	const dispatch = useAppDispatch();
	const CWtheme = useTheme();
	const drawerWidth = 240;
	const matches = useMediaQuery('(min-width:900px)');

	const { isSideBarOpen } = useSelector((state: RootState) => state.ui.sideBar);

	const toogleSidebar = () => {
		if (isSideBarOpen) {
			dispatch(setSideBarOpen(false));
		} else {
			dispatch(setSideBarOpen(true));
		}
	};

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppBar
				position="fixed"
				sx={{
					zIndex: (theme) => theme.zIndex.drawer + 1,
					backgroundColor: CWtheme.palette.background.paper,
				}}
				elevation={0}
			>
				<div
					style={{
						height: '1px',
						width: 'calc(100% - 239px)',
						position: 'absolute',
						top: '60px',
						left: '239px',
						// backgroundColor: CWtheme.palette.grey[300],
					}}
				>
					{' '}
				</div>
				{/* <Typography variant="h6" noWrap component="div">
						Clipped drawer
					</Typography> */}
				<Navigationbar />
			</AppBar>
			<Drawer
				open={isSideBarOpen}
				onClose={toogleSidebar}
				variant={matches ? 'permanent' : 'temporary'}
				sx={{
					width: drawerWidth,
					flexShrink: 0,

					'& .MuiDrawer-paper': {
						width: drawerWidth,
						boxSizing: 'border-box',
						paddingTop: matches ? '57px' : '27px',
						backgroundColor: CWtheme.palette.primary.contrastText,
						border: 'none',
					},
				}}
				className="MainLayout__sidebar"
			>
				{/* <Toolbar /> */}
				{!matches && (
					<div style={{ padding: '0 25px' }}>
						<Logo />
					</div>
				)}
				{sidebar}
			</Drawer>
			<Box
				className="MainLayout__content-wrapper"
				component="main"
				sx={{ flexGrow: 1 }}
			>
				<div className="MainLayout__content">{content}</div>
			</Box>
		</Box>
	);
};

export default MainLayout;
